var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { APPEvent } from "@/events/AppEvents";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { ALLViewer, AnnotationType, NoteStatus, NoteType } from "@@/Annotation";
import { Apphandler } from "@/ipc/MainAppHandler";
import { ObjectUpdateType } from "@/share/models";
import { AccessGroupState } from "@/app/uistore/AccessgroupState";
import { ColorStore } from "@/app/UIComponents/ColorDialog";
import { CommentState } from "@/app/UIComponents/Comments";
import { PdfPageStore } from "@/app/UIComponents/PdfPagestore";
import { ViewerFindState } from "@/app/uistore/ViewerFindState";
import { SelectMemberDialogState } from "@/app/UIComponents/SelectMemberDialog";
import { NoteUI } from "@/app/uistore/NoteUI";
import { NotesFilterState } from "@/app/uistore/NotesFilterState";
import { isIpadScreen } from "@@/Util";
import { NoteDetailsStore } from "@/app/uistore/NoteDetailsStore";
export class AdminMiniViwerStateNew {
    constructor() {
        this.activepagenumber = 1;
        this.scrollnoteid = "";
        this.zoomfactor = isIpadScreen() ? 2 : 1;
        this.loadingactivepage = false;
        this.totalpages = 0;
        this.annotate = false;
        this.viewportwidth = 0;
        this.viewportheight = 0;
        this.links = [];
        this.showlinkdialog = false;
        this.showinoutlinks = new Set();
        this.commentstate = new CommentState();
        this.viewerfindstate = new ViewerFindState();
        this.loadingcomments = false;
        this.annotationtype = undefined;
        this.pagestate = new Map();
        this.mainpagestate = new Map();
        this.sethighlightterms = new Map();
        this.findtermswordindex = new Map();
        this.findterms = new Map();
        this.notesbypage = new Map();
        this.hasdict = false;
        this.textannotationdragging = false;
        this.textannotatestartpage = 0;
        this.annotatepagecods = "";
        this.pageshaveactivehighlight = new Set();
        this.activeannotcolor = "";
        this.notedetailstate = new NoteDetailsStore();
        this.notelinksdialogleft = 0;
        this.notelinksdialogtop = 0;
        this.activenoteboxref = null;
        this.showbookmarklinkdetail = new Set();
        this.activerequestid = "";
        this.activeletrid = "";
        this.activeobjectid = "";
        this.saving = false;
        this.loading = false;
        this.notes = new Map();
        this.activedotednotesid = [];
        this.pages = new Map();
        this.editmode = false;
        this.editnote = undefined;
        this.editnoteid = "";
        this.thickness = 3;
        this.strokewidth = 3;
        this.notestimeout = -1;
        this.lastnotesupdatetime = -1;
        this.accessstorestate = new AccessGroupState();
        this.smstate = new SelectMemberDialogState();
        this.activeaccessids = new Set([ALLViewer]);
        this.appliedaclstr = ALLViewer;
        this.colorstate = new ColorStore();
        this.deletingnote = false;
        this.activedraftid = "";
        this.mainzoomfactor = 0.5;
        this.pagesnumber = [];
        this.showannotation = true;
        this.downx = -1;
        this.downy = -1;
        this.activenoteid = "";
        this.allnotesbypage = new Map();
        this.showfilter = false;
        this.lastcommenttime = -1;
        this.authors = new Map();
        this.notefilterstate = new NotesFilterState();
        this.shownotespanel = !isIpadScreen() ? true : false;
        this.activeuserid = "";
        makeObservable(this);
        this.colorstate.onok = () => {
            this.redrawOngoing();
        };
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            this.setActiveLetr(letr.id);
        });
        // APPEvent.addSubscriberForAdminPdfFilePage((res) => {
        //     if(this.pagestate.has(res.pagenumber)) {
        //         let page = new Uint8Array();
        //         if(res.page !== undefined) {
        //             page = LetrwingCrypto.base64ToBin(res.page);
        //         }
        //         this.pagestate.get((res.pagenumber))?.setPage(page);
        //         this.pagestate.get((res.pagenumber))?.setPageLoading(false);
        //     }
        // });
        APPEvent.addSubscriberForAdminPdfFilePage((res) => {
            var _a, _b;
            if (res.ischooser) {
                return;
            }
            if (res.id !== PdfPageStore.activefileid) {
                return;
            }
            if (this.pagestate.has(res.pagenumber) && res.pagename !== 'summaryfile' && res.pagename !== 'keywords' &&
                !res.pagename.endsWith('-words') && res.pagename !== 'finddict') {
                let page = new Uint8Array();
                if (res.page !== undefined) {
                    page = LetrwingCrypto.base64ToBin(res.page);
                }
                (_a = this.pagestate.get((res.pagenumber))) === null || _a === void 0 ? void 0 : _a.setPage(page);
                (_b = this.pagestate.get((res.pagenumber))) === null || _b === void 0 ? void 0 : _b.setPageLoading(false);
                PdfPageStore.pages.set(res.pagename, page);
            }
            else if (res.pagename.endsWith('-words') && this.pagestate.has(res.pagenumber) && res.page) {
                const page = LetrwingCrypto.fromBase64ToUTF8(res.page);
                PdfPageStore.pages.set(res.pagename, page);
                const pgarr = JSON.parse(page);
                const pdet = this.pagestate.get(res.pagenumber);
                if (pdet) {
                    pdet.setWordDetails(pgarr);
                    const cods = this.sethighlightterms.get(res.pagenumber + 1);
                    if (cods !== undefined && pgarr !== undefined) {
                        const words = pgarr;
                        cods.forEach((cod) => {
                            if (words.length > cod) {
                                const wcod = words[cod];
                                const rect = {
                                    x1: wcod.x1,
                                    y1: wcod.y1,
                                    x2: wcod.x2,
                                    y2: wcod.y2
                                };
                                pdet === null || pdet === void 0 ? void 0 : pdet.setHighCods(rect);
                            }
                        });
                    }
                }
            }
            else if (res.pagename === 'finddict' && res.page) {
                const page = LetrwingCrypto.fromBase64ToUTF8(res.page);
                if (page) {
                    try {
                        const fdict = JSON.parse(page);
                        this.finddict = fdict;
                        this.buildfinddict();
                        this.setHasDict(true);
                    }
                    catch (ex) { }
                }
            }
        });
        APPEvent.addSubscriberForAdminGetNote((notes) => {
            var _a;
            if (this.loading && notes.letrid === this.activeletrid
                && notes.objectid === this.activeobjectid && notes.userid === this.activeuserid) {
                this.notes = new Map();
                notes.note.forEach((n) => {
                    const noteui = this.convertNoteToNoteUI(n);
                    this.notes.set(n.id, noteui);
                    // why do we need to this here??
                    this.authors.set(n.authorid, {
                        authorid: n.authorid,
                        authorname: n.authorname
                    });
                    if (n.updatetime > this.lastnotesupdatetime) {
                        this.lastnotesupdatetime = n.updatetime;
                    }
                });
                this.arrangeNotesByPage();
                this.setLoadingNotes(false);
                if (this.notestimeout) {
                    clearTimeout(this.notestimeout);
                }
                if (this.editnoteid) {
                    this.editnote = this.notes.get(this.editnoteid);
                    if (this.editnote !== undefined && ((_a = this.editnote) === null || _a === void 0 ? void 0 : _a.note) !== undefined) {
                        try {
                            const match = this.editnote.note.data.match.split(":");
                            const stpg = match[1];
                            this.setActivePageNumber(parseInt(stpg) + 1);
                        }
                        catch (ex) {
                        }
                        this.setAppliedAclString(this.editnote.note.aclstr);
                        this.selectAccessids(this.editnote.note.viewer);
                        this.setEditNoteId(this.editnote.note.id);
                    }
                }
                this.notestimeout = setTimeout(() => this.getNotesUpdate(), 5000);
            }
        });
        APPEvent.addSubscriberForNoteUpdate((up) => {
            if (up.letrid === this.activeletrid && up.objectid === this.activeobjectid) {
                /// we good to go here now!!
                let lastupdatetime = -1;
                for (const n of up.notes) {
                    if (n.status !== NoteStatus.Dead) {
                        const snui = this.notes.get(n.id);
                        if (snui != undefined) {
                            snui.setNote(n);
                            continue;
                        }
                        const nui = this.convertNoteToNoteUI(n);
                        this.arrangeNote(nui);
                    }
                    else {
                        // delete this note that's all!
                        const an = this.notes.get(n.id);
                        if (an) {
                            this.deleteNote(an);
                        }
                    }
                    if (n.updatetime > lastupdatetime) {
                        lastupdatetime = n.updatetime;
                    }
                }
                if (lastupdatetime > -1) {
                    this.lastnotesupdatetime = lastupdatetime;
                }
                else {
                    this.lastnotesupdatetime = new Date().getTime();
                }
            }
        });
        APPEvent.addSubscriberForSaveNote((sn) => {
            if (sn.letrid === this.activeletrid && sn.objectid === this.activeobjectid && sn.reqid === this.activerequestid) {
                if (sn.note !== undefined) {
                    const nui = this.convertNoteToNoteUI(sn.note);
                    this.notes.set(sn.note.id, nui);
                    this.arrangeNote(nui);
                }
                // if (this.commentstate.comments.size >  0) {
                //     const com: Comment = {
                //         id: Math.random() + "",
                //         data: new EncryptBox(),
                //         datastr: text,
                //         parentid: "",
                //         authorid: rstore.authStore.userid,
                //         updatetime: new Date().getTime(),
                //         status: NoteStatus.Live
                //     };
                //     this.commentstate.setSendingComment(com);
                //     this.saveComment(com);
                // }
                this.addActiveAnnotationType(undefined);
                this.clearAllOnGoingTextAnn();
                if (sn.note === undefined) {
                    APPEvent.publishApperror("Sorry, failed to " + (this.editmode ? "update" : "add") + " the note. Please try again later");
                }
                this.setEditMode(false);
                this.setEditNoteId("");
                this.setSaving(false);
                this.editnote = undefined;
                this.notedetailstate.setContent("");
                this.setAppliedAclString("");
                this.selectAccessids([ALLViewer]);
            }
        });
        APPEvent.addSubscriberForNoteDelete((req) => {
            var _a, _b;
            if (req.type === ObjectUpdateType.Comment) {
                if (req.objectid === this.editnoteid) {
                    if (req.ok) {
                        this.commentstate.removeComment(req.id);
                    }
                    else {
                        APPEvent.publishApperror("Sorry, failed to delete the comment.");
                        this.commentstate.removeCommentFromDelete(req.id);
                    }
                }
                return;
            }
            if (this.deletingnote && ((_b = (_a = this.editnote) === null || _a === void 0 ? void 0 : _a.note) === null || _b === void 0 ? void 0 : _b.id) === req.id) {
                if (!req.ok) {
                    APPEvent.publishApperror("Sorry, failed to delete the note.");
                }
                else {
                    this.deleteNote(this.editnote);
                }
                this.setSaving(false);
                this.setEditMode(false);
                this.setEditNoteId("");
                this.editnote = undefined;
                this.notedetailstate.setContent("");
                this.setAppliedAclString("");
                this.selectAccessids([ALLViewer]);
                this.setDeletingNote(false);
            }
        });
        APPEvent.addSubscriberForAdminGetComments((res) => {
            if (res.noteid === this.editnoteid && res.userid === this.activeuserid) {
                // lets just add these now
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.commentstate.removeComment(com.id);
                    }
                    else {
                        this.commentstate.setComment(com);
                    }
                    if (com.updatetime > this.lastcommenttime) {
                        this.lastcommenttime = com.updatetime;
                    }
                });
                this.setLoadingComments(false);
            }
        });
        APPEvent.addSubscriberForSaveComments((res) => {
            if (this.commentstate.sendingcomments.has(res.replaceid)) {
                this.commentstate.removeSendingComment(res.replaceid);
                if (res.comment !== undefined) {
                    this.commentstate.setComment(res.comment);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add comment");
                }
            }
        });
    }
    setActiveLetr(id) {
        this.activeletrid = id;
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    resetFilter() {
        this.notes.forEach((n, k) => {
            if (n.note !== undefined) {
                n.setVisible(true);
            }
        });
    }
    setFilter(filter) {
        for (const n of this.notes.values()) {
            if (n.note !== undefined) {
                if (filter.toDate !== undefined && filter.toDate > 0) {
                    if (n.note.updatetime <= filter.toDate) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromDate !== undefined && filter.fromDate > 0) {
                    if (n.note.updatetime >= filter.fromDate - 1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.toPage !== undefined && filter.toPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg <= filter.toPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromPage !== undefined && filter.fromPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg >= filter.fromPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.type != undefined && filter.type.length > 0) {
                    if (filter.type.indexOf(n.note.data.notetype) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.authors != undefined && filter.authors.length > 0) {
                    if (filter.authors.indexOf(n.note.authorid) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.notetype.length > 0) {
                    if (n.note.linkboxes !== undefined && n.note.linkboxes.length > 0 && filter.notetype.indexOf(n.note.type) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.filterlinknote) {
                    if (n.note.linkboxes === undefined) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                n.setVisible(true);
            }
        }
    }
    setShowFilter(show) {
        this.showfilter = show;
    }
    convertNoteToNoteUI(note) {
        const noteui = new NoteUI();
        noteui.setNote(note);
        noteui.setVisible(true);
        return noteui;
    }
    getVisNoteActiveIndex(id) {
        return this.activedotednotesid.indexOf(id);
    }
    getAllNotesArray() {
        const allnotesbyid = Array.from(this.notes.values()).filter((n) => n.visible).sort(this.sortNoteByPage);
        this.activedotednotesid = allnotesbyid.map((n) => { var _a, _b; return (_b = (_a = n.note) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ''; });
        return allnotesbyid;
    }
    sort(n1, n2) {
        const parts1 = n1.data.match.split(":");
        const parts2 = n2.data.match.split(":");
        const n1page = parseInt(parts1[1]) + 1;
        const n2page = parseInt(parts2[1]) + 1;
        const t1 = n1.updatetime;
        const t2 = n2.updatetime;
        if (n1page === n2page) {
            if (n1.data.notetype === AnnotationType.Text && n2.data.notetype === AnnotationType.Text) {
                const n1startindex = parseInt(parts1[2]);
                const n2startindex = parseInt(parts2[2]);
                if (n2startindex === n1startindex) {
                    return t1 - t2;
                }
                return n1startindex - n2startindex;
            }
            else if (n1.data.notetype === AnnotationType.Rectangle && n2.data.notetype === AnnotationType.Rectangle) {
            }
            else if (n1.data.notetype === AnnotationType.Freehand && n2.data.notetype === AnnotationType.Rectangle) {
            }
        }
        return n1page > n2page ? 1 : -1;
    }
    sortNoteByPage(nui1, nui2) {
        const n1 = nui1.note;
        const n2 = nui2.note;
        if (n1 !== undefined && n2 !== undefined) {
            const parts1 = n1.data.match.split(":");
            const parts2 = n2.data.match.split(":");
            const n1page = parseInt(parts1[1]) + 1;
            const n2page = parseInt(parts2[1]) + 1;
            if (n1page === n2page) {
                const t1 = n1.updatetime;
                const t2 = n2.updatetime;
                return t1 - t2;
            }
            return n1page - n2page;
        }
        return 0;
    }
    sortByTime(n1, n2) {
        const parts1 = n1.data.match.split(":");
        const parts2 = n2.data.match.split(":");
        const n1page = parseInt(parts1[1]) + 1;
        const n2page = parseInt(parts2[1]) + 1;
        const t1 = n1.updatetime;
        const t2 = n2.updatetime;
        if (t1 === t2) {
            return n1page - n2page;
        }
        return t1 - t2;
    }
    sortNoteByPageAndCods(n1, n2) {
        const parts1 = n1.data.match.split(":");
        const parts2 = n2.data.match.split(":");
        const n1page = parseInt(parts1[1]) + 1;
        const n2page = parseInt(parts2[1]) + 1;
        if (n1page === n2page) {
            // lets check the type 
            if (n1.data.notetype !== n2.data.notetype) {
                // text followed by rectangel followed by free hand
                if (n1.data.notetype === AnnotationType.Text) {
                    return -1;
                }
                if (n2.data.notetype === AnnotationType.Text) {
                    return 1;
                }
                if (n1.data.notetype === AnnotationType.Rectangle) {
                    return -1;
                }
                if (n2.data.notetype === AnnotationType.Rectangle) {
                    return 1;
                }
            }
            const t1 = n1.updatetime;
            const t2 = n2.updatetime;
            if (n1.data.notetype === AnnotationType.Text) {
                // compare the words start position 
                const parts1 = n1.data.match.split(":");
                const parts2 = n2.data.match.split(":");
                const n1startindex = parseInt(parts1[2]);
                const n2startindex = parseInt(parts2[2]);
                if (n2startindex === n1startindex) {
                    return t1 - t2;
                }
                return n1startindex - n2startindex;
            }
            else if (n1.data.notetype === AnnotationType.Rectangle) {
                // compare top1 and top2 if equal compare left1 and left2 if equal return time diff
                let rect1 = [];
                let rect2 = [];
                if (parts1.length > 5) {
                    const bits = parts1;
                    rect1 = [parseFloat(bits[2]), parseFloat(bits[3]),
                        parseFloat(bits[4]),
                        parseFloat(bits[5])];
                }
                if (parts2.length > 5) {
                    const bits = parts2;
                    rect2 = [parseFloat(bits[2]), parseFloat(bits[3]),
                        parseFloat(bits[4]),
                        parseFloat(bits[5])];
                }
                if (rect1.length > 0 && rect2.length > 0) {
                    const top1 = Math.min(rect1[3], rect1[1]);
                    const top2 = Math.min(rect2[0], rect2[2]);
                    const diff = top1 - top2;
                    if (diff != 0) {
                        return diff;
                    }
                    const left1 = Math.min(rect1[0], rect1[2]);
                    const left2 = Math.min(rect2[0], rect2[2]);
                    const ldiff = left1 - left2;
                    if (ldiff != 0) {
                        return ldiff;
                    }
                    return t1 - t2;
                }
            }
            else {
                const rects = n1.data.boxes;
                const rects2 = n2.data.boxes;
                let top1 = 0;
                let left1 = 0;
                let y1 = 0;
                for (let point of rects) {
                    if (y1 === 0 || point[1] < y1) {
                        y1 = point[1];
                        top1 = point[1];
                        left1 = point[0];
                    }
                }
                let top2 = 0;
                let left2 = 0;
                let y2 = 0;
                for (let point of rects2) {
                    if (y2 === 0 || point[1] < y2) {
                        y2 = point[1];
                        top2 = point[1];
                        left2 = point[0];
                    }
                }
                // now we have everything lets do some comparison!
                const diff = top1 - top2;
                if (diff != 0) {
                    return diff;
                }
                const ldiff = left1 - left2;
                if (ldiff != 0) {
                    return ldiff;
                }
                return t1 - t2;
            }
            return t1 - t2;
        }
        return n1page > n2page ? 1 : -1;
    }
    sortRectangleNotes(n1, n2) {
        const parts1 = n1.data.match.split(":");
        const parts2 = n2.data.match.split(":");
        const n1page = parseInt(parts1[1]) + 1;
        const n2page = parseInt(parts2[1]) + 1;
        const n1startindex = parseInt(parts1[5]);
        const n2startindex = parseInt(parts2[5]);
        const t1 = n1.updatetime;
        const t2 = n2.updatetime;
        if (n1page === n2page) {
            if (n2startindex === n1startindex) {
                return t1 - t2;
            }
            return n1startindex - n2startindex;
        }
        return n1page > n2page ? 1 : -1;
    }
    setShowLinkDialog(show) {
        this.showlinkdialog = show;
    }
    sortFreeHandNotes(n1, n2) {
        const parts1 = n1.data.match.split(":");
        const parts2 = n2.data.match.split(":");
        const n1page = parseInt(parts1[1]) + 1;
        const n2page = parseInt(parts2[1]) + 1;
        const t1 = n1.updatetime;
        const t2 = n2.updatetime;
        const boxes1 = n1.data.boxes.sort((a, b) => {
            return a[1] - b[1];
        });
        const boxes2 = n2.data.boxes.sort((a, b) => {
            return a[1] - b[1];
        });
        const box1Y0 = boxes1[0][1];
        const box1Y1 = boxes1[boxes1.length - 1][1];
        const box2Y0 = boxes2[0][1];
        const box2Y1 = boxes2[boxes2.length - 1][1];
        if (box1Y0 === box2Y0 && box1Y1 === box2Y1) {
            return t1 - t2;
        }
        return box1Y0 > box2Y0 && box1Y1 > box2Y1 ? 1 : -1;
    }
    sortTextNotes(note1, note2) {
        const parts1 = note1.data.match.split(":");
        const parts2 = note2.data.match.split(":");
        const n1page = parseInt(parts1[3]) + 1;
        const n2page = parseInt(parts2[3]) + 1;
        const n1startindex = parseInt(parts1[2]);
        const n2startindex = parseInt(parts2[2]);
        const t1 = note1.updatetime;
        const t2 = note2.updatetime;
        if (n1page === n2page) {
            if (n2startindex === n1startindex) {
                return t1 - t2;
            }
            return n1startindex - n2startindex;
        }
        return n1page > n2page ? 1 : -1;
    }
    buildfinddict() {
        if (!this.finddict) {
            return;
        }
        const terms = [];
        for (const word of this.finddict.words) {
            const wt = word.word;
            for (const pg of word.pagedictionay) {
                pg.matchindex.sort((w1, w2) => w1 - w2).forEach((w) => {
                    terms.push({
                        term: wt,
                        pagenumber: pg.pagenumber,
                        wordindex: w
                    });
                });
            }
        }
        const fobjs = terms.sort((term1, term2) => {
            const diff = term1.pagenumber - term2.pagenumber;
            if (diff != 0) {
                return diff;
            }
            return term1.wordindex - term2.wordindex;
        }).map((term) => ({
            text: term.term,
            data: term
        }));
        this.viewerfindstate.setItems(fobjs);
    }
    clearFindTerms() {
        this.findtermswordindex.clear();
    }
    addFindTermMatch(term) {
        term.forEach((term) => {
            var _a;
            if (!this.findtermswordindex.has(term.pagenumber)) {
                this.findtermswordindex.set(term.pagenumber, new Set());
            }
            (_a = this.findtermswordindex.get(term.pagenumber)) === null || _a === void 0 ? void 0 : _a.add(term.wordindex);
        });
    }
    getNotesForPage(pgnumber) {
        const objs = this.notesbypage.get(pgnumber);
        return objs !== null && objs !== void 0 ? objs : [];
    }
    arrangeNotesByPage() {
        // lets now arrange this 
        for (const [_, note] of this.notes) {
            this.arrangeNote(note);
        }
    }
    deleteLink(link) {
        const id = this.links.indexOf(link);
        if (id !== undefined && id > -1) {
            this.links.splice(id, 1);
        }
    }
    clearLinks() {
        this.links.splice(0, this.links.length);
    }
    setLink(link) {
        this.links.push(link);
    }
    setShowAnnotation(show) {
        this.showannotation = show;
    }
    loadComments() {
        if (this.loadingcomments || !this.editnoteid) {
            return;
        }
        this.setLoadingComments(true);
        const getcoom = {
            letrid: this.activeletrid,
            objectid: this.activeobjectid,
            noteid: this.editnoteid,
            userid: this.activeuserid,
            floating: false
        };
        Apphandler.sendMessage("admingetcomments", getcoom);
    }
    redrawOngoing() {
        for (const [pg, state] of this.pagestate) {
            if (this.annotationtype === AnnotationType.Text) {
                state.redrawOnGoingTextAnnotation(this.colorstate.color);
            }
            else if (this.annotationtype === AnnotationType.Rectangle) {
                state.redrawOnGoingRectangle(this.colorstate.color, this.thickness);
            }
            else if (this.annotationtype === AnnotationType.Freehand) {
                state.redrawOnGoingFreeHand(this.colorstate.color, this.thickness);
            }
        }
        for (const [pg, state] of this.mainpagestate) {
            if (this.annotationtype === AnnotationType.Text) {
                state.redrawOnGoingTextAnnotation(this.colorstate.color);
            }
            else if (this.annotationtype === AnnotationType.Rectangle) {
                state.redrawOnGoingRectangle(this.colorstate.color, this.thickness);
            }
            else if (this.annotationtype === AnnotationType.Freehand) {
                state.redrawOnGoingFreeHand(this.colorstate.color, this.thickness);
            }
        }
    }
    setNoteLinksDialogLeft(left) {
        this.notelinksdialogleft = left;
    }
    removeShowBookmarkDetail(id) {
        this.showbookmarklinkdetail.delete(id);
    }
    setShowBookmark(id) {
        this.showbookmarklinkdetail.add(id);
    }
    clearShowBookmark() {
        this.showbookmarklinkdetail.clear();
    }
    setNoteLinksDialogTop(top) {
        this.notelinksdialogtop = top;
    }
    setDeletingNote(dn) {
        this.deletingnote = dn;
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    setAppliedAclString(str) {
        this.appliedaclstr = str;
    }
    setThickness(th) {
        this.thickness = th;
        // lets do something funny here!
        this.redrawOngoing();
    }
    setSWidth(th) {
        this.strokewidth = th;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    removeActiveAccessId(id) {
        this.activeaccessids.delete(id);
    }
    deleteEditNote() {
        if (this.editmode && this.editnote !== undefined && this.editnote.note !== undefined) {
            const req = {
                letrid: this.activeletrid,
                objectid: this.activeobjectid,
                id: this.editnote.note.id
            };
            this.setDeletingNote(true);
            Apphandler.sendMessage("deletenote", req);
        }
    }
    deleteSelectedNote(noteid) {
        if (this.editmode && this.editnote) {
            const req = {
                letrid: this.activeletrid,
                objectid: this.activeobjectid,
                id: noteid
            };
            this.setDeletingNote(true);
            Apphandler.sendMessage("deletenote", req);
        }
    }
    saveComment(com) {
        var _a;
        if (this.editmode && this.editnoteid) {
            const savereq = {
                letrid: this.activeletrid,
                objectid: this.activeobjectid,
                replaceid: com.id,
                text: (_a = com.datastr) !== null && _a !== void 0 ? _a : "",
                noteid: this.editnoteid
            };
            Apphandler.sendMessage("addcomment", savereq);
        }
    }
    deleteNote(noteui) {
        if (noteui.note !== undefined) {
            const note = noteui.note;
            const makring = note.data.match;
            const bits = makring.split(":");
            this.notes.delete(note.id);
            if (note.data.notetype === AnnotationType.Text) {
                const stpg = parseInt(bits[1]);
                const endpg = parseInt(bits[3]);
                for (let i = stpg; i <= endpg; i++) {
                    const pgstt = this.pagestate.get(i);
                    if (pgstt) {
                        pgstt.removeNote(noteui);
                    }
                    const mpgstt = this.mainpagestate.get(i);
                    if (mpgstt) {
                        mpgstt.removeNote(noteui);
                    }
                }
            }
            else if (note.data.notetype === AnnotationType.Rectangle) {
                const stpg = parseInt(bits[1]);
                const pgstt = this.pagestate.get(stpg);
                if (pgstt) {
                    pgstt.removeNote(noteui);
                }
                const mpgstt = this.mainpagestate.get(stpg);
                if (mpgstt) {
                    mpgstt.removeNote(noteui);
                }
            }
        }
    }
    arrangeNote(noteui) {
        var _a, _b;
        if (noteui.note !== undefined) {
            const note = noteui.note;
            const addtopage = true;
            const makring = note.data.match;
            const bits = makring.split(":");
            const stpg = parseInt(bits[1]);
            if (note.data.notetype === AnnotationType.Text) {
                const endpg = parseInt(bits[3]);
                for (let i = stpg; i <= endpg; i++) {
                    const pgstt = this.pagestate.get(i);
                    const mpgstt = this.mainpagestate.get(i);
                    if (addtopage && pgstt) {
                        pgstt.addNotes([noteui]);
                    }
                    if (addtopage && mpgstt) {
                        mpgstt.addNotes([noteui]);
                    }
                    if (!this.notesbypage.has(i)) {
                        this.notesbypage.set(i, []);
                    }
                    (_a = this.notesbypage.get(i)) === null || _a === void 0 ? void 0 : _a.push(noteui);
                }
            }
            else if (note.data.notetype === AnnotationType.Rectangle ||
                note.data.notetype === AnnotationType.Freehand) {
                const pgstt = this.pagestate.get(stpg);
                const mpgstt = this.mainpagestate.get(stpg);
                if (addtopage && pgstt) {
                    pgstt.addNotes([noteui]);
                }
                if (addtopage && mpgstt) {
                    mpgstt.addNotes([noteui]);
                }
                if (!this.notesbypage.has(stpg)) {
                    this.notesbypage.set(stpg, []);
                }
                (_b = this.notesbypage.get(stpg)) === null || _b === void 0 ? void 0 : _b.push(noteui);
            }
        }
    }
    getCommentUpdate() {
        if (this.loading || !this.activeletrid || !this.activeobjectid || !this.editnoteid) {
            return;
        }
        const comms = this.commentstate.getComments();
        if (this.lastcommenttime == -1) {
            this.lastcommenttime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activeletrid,
            objectid: this.activeobjectid,
            since: this.lastcommenttime,
            noteid: this.editnoteid,
            referencid: this.activedraftid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getNotesUpdate() {
        this.getCommentUpdate();
        if (this.loading || !this.activeletrid || !this.activeobjectid) {
            return;
        }
        if (this.lastnotesupdatetime === -1) {
            this.lastnotesupdatetime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activeletrid,
            objectid: this.activeobjectid,
            since: this.lastnotesupdatetime,
            referencid: this.activedraftid,
            updatetype: ObjectUpdateType.Note
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
        this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
    }
    getAllNotes() {
        if (this.loading) {
            return;
        }
        this.lastnotesupdatetime = -1;
        this.setLoadingNotes(true);
        const req = {
            letrid: this.activeletrid,
            objectid: this.activeobjectid,
            referencid: this.activedraftid,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetnotes", req);
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
    }
    addHightlight(pg, posi) {
        var _a;
        if (!this.sethighlightterms.has(pg)) {
            this.sethighlightterms.set(pg, new Set());
        }
        (_a = this.sethighlightterms.get(pg)) === null || _a === void 0 ? void 0 : _a.add(posi);
    }
    clearAllOngoingRects() {
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (!mode) {
            this.activeaccessids = new Set([ALLViewer]);
            this.appliedaclstr = "---";
        }
    }
    setEditNoteId(id) {
        this.editnoteid = id;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.loadComments();
        this.lastcommenttime = -1;
        this.scrollnoteid = id;
    }
    setSaving(saving) {
        this.saving = saving;
    }
    setActiveAnnotColor(color) {
        this.activeannotcolor = color;
    }
    clearAllOnGoingTextAnn(miniviewer = true) {
        const state = miniviewer ? this.pagestate : this.mainpagestate;
        state.forEach((st) => {
            st.clearTextRects();
        });
        this.pageshaveactivehighlight.clear();
    }
    clearAllAnnotationFromPageAbove(mypage, miniviewer = true) {
        var _a;
        const state = miniviewer ? this.pagestate : this.mainpagestate;
        for (let i = mypage - 1; i >= 0; i--) {
            (_a = state.get(i)) === null || _a === void 0 ? void 0 : _a.clearTextRects();
            this.pageshaveactivehighlight.delete(i);
        }
    }
    clearAllAnnotationFromPageBelow(mypage, miniviewer = true) {
        var _a;
        const state = miniviewer ? this.pagestate : this.mainpagestate;
        for (let i = mypage + 1; i < state.size; i++) {
            (_a = state.get(i)) === null || _a === void 0 ? void 0 : _a.clearTextRects();
            this.pageshaveactivehighlight.delete(i);
        }
    }
    addPgHasActiveHighlight(pg) {
        this.pageshaveactivehighlight.add(pg);
    }
    paintAllPagesBelowMe(mypagenumber, miniviewer = true) {
        const state = miniviewer ? this.pagestate : this.mainpagestate;
        for (let i = mypagenumber + 1; i <= this.textannotatestartpage; i++) {
            const st = state.get(i);
            if (i === this.textannotatestartpage) {
                // we need to paint everything between!
                st === null || st === void 0 ? void 0 : st.paintThingBetween(0, 0, st.downx, st.downy);
            }
            else {
                const posrtpoint = st === null || st === void 0 ? void 0 : st.getPdfPoint(st.pageviewportwidth + 100, st.pageviewportheight + 100);
                if (posrtpoint && (st === null || st === void 0 ? void 0 : st.paintThingBetween(0, 0, posrtpoint[0], posrtpoint[1]))) {
                    this.addPgHasActiveHighlight(i);
                }
            }
        }
    }
    paintAllPagesAboveMe(mypagenumber, miniviewer = true) {
        const state = miniviewer ? this.pagestate : this.mainpagestate;
        for (let i = mypagenumber - 1; i >= this.textannotatestartpage; i--) {
            const st = state.get(i);
            const posrtpoint = st === null || st === void 0 ? void 0 : st.getPdfPoint(st.pageviewportwidth + 100, st.pageviewportheight + 100);
            if (!posrtpoint) {
                continue;
            }
            if (i === this.textannotatestartpage) {
                // we need to paint everything between!
                st === null || st === void 0 ? void 0 : st.paintThingBetween(st.downx, st.downy, posrtpoint[0], posrtpoint[1]);
            }
            else {
                if (st === null || st === void 0 ? void 0 : st.paintThingBetween(0, 0, posrtpoint[0], posrtpoint[1])) {
                    this.addPgHasActiveHighlight(i);
                }
            }
        }
    }
    setTextAnnotateStartPage(pg) {
        this.textannotatestartpage = pg;
    }
    setTextAnnotationDragging(dragging) {
        this.textannotationdragging = dragging;
    }
    addActiveAnnotationType(type) {
        this.annotationtype = type;
        this.setAppliedAclString("");
        this.activeaccessids = new Set([ALLViewer]);
        this.commentstate.clear();
    }
    setViewportwidth(wid) {
        this.viewportwidth = wid;
    }
    setViewportHeight(hg) {
        this.viewportheight = hg;
    }
    loadMorePages() {
        if (this.pagesnumber.length >= this.totalpages) {
            return;
        }
        this.increamentPageNumber();
    }
    increamentPageNumber() {
        const inc = this.pagesnumber.length + 5 > this.totalpages ? this.totalpages - this.pagesnumber.length
            : 5;
        for (let i = 0; i < inc; i++) {
            this.pagesnumber.push(this.pagesnumber.length + i);
        }
    }
    setHasDict(has) {
        this.hasdict = has;
    }
    setShowLinksForNote(noteid) {
        this.showinoutlinks.add(noteid);
    }
    clearShowLinksForNote() {
        this.showinoutlinks.clear();
    }
    removeShowLinksForNote(noteid) {
        this.showinoutlinks.delete(noteid);
    }
    reset() {
        this.clearShowBookmark();
        this.showinoutlinks.clear();
        this.setShowLinkDialog(false);
        this.clearLinks();
        this.hasdict = false;
        this.pagesnumber = [];
        this.notesbypage.clear();
        this.findterms.clear();
        this.findtermswordindex.clear();
        this.pagestate.clear();
        this.mainpagestate.clear();
        this.setActivePageNumber(1);
        this.setZoomFactor(isIpadScreen() ? 2 : 1);
        this.setMainZoomFactor(0.5);
        this.setTotalPages(1);
        this.setTextAnnotationDragging(false);
        this.sethighlightterms.clear();
        this.clearAllOnGoingTextAnn();
        this.setSaving(false);
        this.setLoadingNotes(false);
        this.activeaccessids = new Set([ALLViewer]);
        this.appliedaclstr = ALLViewer;
        this.annotationtype = undefined;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.lastnotesupdatetime = -1;
        this.lastcommenttime = -1;
        this.setEditMode(false);
        this.setEditNoteId("");
        this.editnote = undefined;
        this.setShowNotesPanel(!isIpadScreen() ? true : false);
    }
    setLoadingNotes(loading) {
        this.loading = loading;
    }
    setTotalPages(pages) {
        this.totalpages = pages;
    }
    setLoadingActivePage(loading) {
        this.loadingactivepage = loading;
    }
    setActivePageNumber(num) {
        this.activepagenumber = num;
    }
    saveEdit() {
        if (this.editmode && this.editnote !== undefined && this.editnote.note !== undefined) {
            // lets get the new two filed and that's all
            this.editnote.note.aclstr = this.appliedaclstr;
            this.editnote.note.viewer = Array.from(this.activeaccessids);
            this.editnote.note.data.detail = [{ key: 'systemtext', value: this.notedetailstate.text }];
            this.setSaving(true);
            this.activerequestid = this.editnote.id;
            const req = {
                reqid: this.activerequestid,
                letrid: this.activeletrid,
                objectid: this.activeobjectid,
                note: this.editnote.note,
                comment: []
            };
            Apphandler.sendMessage("updatenote", req);
        }
    }
    saveAnnotation(miniviwer = true) {
        var _a, _b, _c, _d;
        if (this.pageshaveactivehighlight.size === 0) {
            return;
        }
        if (this.annotationtype === AnnotationType.Text) {
            this.setSaving(true);
            let stpage = this.textannotatestartpage;
            let endpage = this.textannotatestartpage;
            // now lets do something interesting here 
            for (const pgs of this.pageshaveactivehighlight) {
                if (stpage > pgs) {
                    stpage = pgs;
                }
                if (endpage < pgs) {
                    endpage = pgs;
                }
            }
            // lets now get first word and lst word that's it!
            const state = miniviwer ? this.pagestate : this.mainpagestate;
            let marking = "text:" + stpage + ":" + ((_a = state.get(stpage)) === null || _a === void 0 ? void 0 : _a.startword) + ":" + endpage + ":" +
                ((_b = state.get(endpage)) === null || _b === void 0 ? void 0 : _b.endword);
            const databox = {
                detail: [{ key: 'systemtext', value: this.notedetailstate.text }],
                notetype: AnnotationType.Text,
                boxes: [],
                match: marking,
                color: this.colorstate.color,
                storekthickness: -1
            };
            const note = {
                id: "",
                data: databox,
                type: NoteType.Note,
                viewer: Array.from(this.activeaccessids),
                parentid: "",
                authorname: "",
                authorid: "",
                updatetime: 0,
                replycount: 0,
                aclstr: "---",
                notereference: this.activedraftid
            };
            this.activerequestid = Math.random() + "";
            if (this.links.length > 0) {
                note.linkboxes = this.links;
            }
            const req = {
                reqid: this.activerequestid,
                letrid: this.activeletrid,
                objectid: this.activeobjectid,
                note: note,
                comment: this.commentstate.getComments()
            };
            Apphandler.sendMessage("savenote", req);
        }
        else if (this.annotationtype === AnnotationType.Rectangle) {
            const pg = Array.from(this.pageshaveactivehighlight)[0];
            const state = miniviwer ? this.pagestate : this.mainpagestate;
            const rects = (_c = state.get(pg)) === null || _c === void 0 ? void 0 : _c.activeTextAnnotRects;
            if (rects !== undefined) {
                this.setSaving(true);
                const marking = "box:" + pg + ":" + (Array.from(rects)[0].join(":"));
                const databox = {
                    detail: [{ key: 'systemtext', value: this.notedetailstate.text }],
                    notetype: AnnotationType.Rectangle,
                    boxes: Array.from(rects),
                    match: marking,
                    color: this.colorstate.color,
                    storekthickness: this.thickness
                };
                const note = {
                    id: "",
                    data: databox,
                    type: NoteType.Note,
                    viewer: Array.from(this.activeaccessids),
                    parentid: "",
                    authorname: "",
                    authorid: "",
                    replycount: 0,
                    updatetime: 0,
                    aclstr: "---",
                    notereference: this.activedraftid
                };
                if (this.links.length > 0) {
                    note.linkboxes = this.links;
                }
                const req = {
                    reqid: this.activerequestid,
                    letrid: this.activeletrid,
                    objectid: this.activeobjectid,
                    note: note,
                    comment: this.commentstate.getComments()
                };
                Apphandler.sendMessage("savenote", req);
            }
        }
        else if (this.annotationtype === AnnotationType.Freehand) {
            const pg = Array.from(this.pageshaveactivehighlight)[0];
            const state = miniviwer ? this.pagestate : this.mainpagestate;
            const rects = (_d = state.get(pg)) === null || _d === void 0 ? void 0 : _d.activefreehandpoints;
            if (rects !== undefined) {
                this.setSaving(true);
                const marking = "freehand:" + pg;
                const databox = {
                    detail: [{ key: 'systemtext', value: this.notedetailstate.text }],
                    notetype: AnnotationType.Freehand,
                    boxes: Array.from(rects),
                    match: marking,
                    color: this.colorstate.color,
                    storekthickness: this.thickness
                };
                const note = {
                    id: "",
                    data: databox,
                    type: NoteType.Note,
                    viewer: Array.from(this.activeaccessids),
                    parentid: "",
                    authorname: "",
                    authorid: "",
                    replycount: 0,
                    updatetime: 0,
                    aclstr: "---",
                    notereference: this.activedraftid
                };
                if (this.links.length > 0) {
                    note.linkboxes = this.links;
                }
                const req = {
                    reqid: this.activerequestid,
                    letrid: this.activeletrid,
                    objectid: this.activeobjectid,
                    note: note,
                    comment: this.commentstate.getComments()
                };
                Apphandler.sendMessage("savenote", req);
            }
        }
    }
    findMatchFor(pagenumber, x, y) {
        const ps = this.pagestate.get(pagenumber);
        if (ps !== undefined) {
            return ps.findMatchFor(x, y);
        }
        return undefined;
    }
    cleanup() {
    }
    setActivePageNumberStr(num) {
        this.activepagenumber = num;
    }
    setZoomFactor(fc) {
        this.zoomfactor = fc;
        for (const pgstate of Array.from(this.pagestate.values())) {
            pgstate.setWidth((window.innerWidth * .40) * fc);
        }
    }
    setMainZoomFactor(fc) {
        this.mainzoomfactor = fc;
        for (const pgstate of Array.from(this.pagestate.values())) {
            pgstate.setMainWidth((window.innerWidth - 200) * fc);
        }
    }
    deleteComment(id) {
        const req = {
            letrid: this.activeletrid,
            objectid: this.editnoteid,
            id: id
        };
        Apphandler.sendMessage("deletecomment", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "activepagenumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "zoomfactor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "loadingactivepage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "totalpages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "annotate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "viewportwidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "viewportheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminMiniViwerStateNew.prototype, "links", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "showlinkdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminMiniViwerStateNew.prototype, "showinoutlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminMiniViwerStateNew.prototype, "annotationtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminMiniViwerStateNew.prototype, "findtermswordindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "hasdict", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "textannotationdragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "textannotatestartpage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "annotatepagecods", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminMiniViwerStateNew.prototype, "pageshaveactivehighlight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "activeannotcolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "notelinksdialogleft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "notelinksdialogtop", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminMiniViwerStateNew.prototype, "showbookmarklinkdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminMiniViwerStateNew.prototype, "notes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "editnoteid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "thickness", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "strokewidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminMiniViwerStateNew.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminMiniViwerStateNew.prototype, "appliedaclstr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "deletingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "mainzoomfactor", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminMiniViwerStateNew.prototype, "pagesnumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "showannotation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminMiniViwerStateNew.prototype, "authors", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMiniViwerStateNew.prototype, "shownotespanel", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setActiveLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setShowLinkDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearFindTerms", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "addFindTermMatch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "deleteLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setShowAnnotation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setNoteLinksDialogLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "removeShowBookmarkDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setShowBookmark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearShowBookmark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setNoteLinksDialogTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setAppliedAclString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setThickness", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setSWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "removeActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setEditNoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setActiveAnnotColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearAllOnGoingTextAnn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearAllAnnotationFromPageAbove", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearAllAnnotationFromPageBelow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "addPgHasActiveHighlight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setTextAnnotateStartPage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setTextAnnotationDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "addActiveAnnotationType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setViewportwidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setViewportHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "loadMorePages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "increamentPageNumber", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setHasDict", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "clearShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "removeShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setTotalPages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setLoadingActivePage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setActivePageNumber", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setActivePageNumberStr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setZoomFactor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMiniViwerStateNew.prototype, "setMainZoomFactor", null);
